import { Icon, Text } from "@southfields-digital/mxmz-react-ui";
import { useState } from "react";

type GraphicGroupProps = {
	name: string;
	count?: number;
	defaultOpen?: boolean;
	open?: boolean;
	onToggle?: () => void;
	children: React.ReactNode;
};

export default function GraphicGroup({
	name,
	count,
	defaultOpen = true,
	open: openProp,
	onToggle,
	children,
}: GraphicGroupProps) {
	const [openState, setOpenState] = useState(defaultOpen);
	const isControlled = openProp !== undefined;
	const open = isControlled ? openProp : openState;

	const handleToggle = () => {
		if (isControlled) onToggle?.();
		else setOpenState((v) => !v);
	};

	return (
		<div>
			<button
				type="button"
				onClick={handleToggle}
				className="flex items-center gap-2 w-full h-9 px-3 bg-elevated-1 hover:bg-elevated-0 transition-colors cursor-pointer"
			>
				<Icon
					icon="chevron-down"
					size={12}
					weight="bold"
					className={`text-gray-500 shrink-0 transition-transform ${open ? "" : "-rotate-90"}`}
				/>
				<Text className="text-xs font-medium text-foreground truncate">{name}</Text>
				<span className="text-xs text-gray-500 ml-auto shrink-0">{count}</span>
			</button>
			{open && <div className="flex flex-col">{children}</div>}
		</div>
	);
}
